import MuiDrawer from "@mui/material/Drawer";

import { CSSObject, styled, Theme } from "@mui/material";

const DRAWER_OPEN_WIDTH = 250;
const DRAWER_COLLAPSED_WIDTH = 68;

const openedMixin = (theme: Theme): CSSObject => ({
  width: DRAWER_OPEN_WIDTH,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme: Theme): CSSObject => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: DRAWER_COLLAPSED_WIDTH,
});

export const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})<{ open: boolean }>(({ theme, open }) => ({
  width: open ? DRAWER_OPEN_WIDTH : DRAWER_COLLAPSED_WIDTH,
  padding: 0,
  flexShrink: 0,

  "@media (max-width: 1300px)": {
    display: "none",
  },

  "& .MuiDrawer-paper": {
    boxShadow: "none",
    backgroundColor: theme.colors.grey100,
    width: open ? DRAWER_OPEN_WIDTH : DRAWER_COLLAPSED_WIDTH,
    padding: 0,
    borderRadius: 0,
    borderRight: `1px solid ${theme.colors.grey400}`,
  },

  variants: [
    {
      props: ({ open }: { open: boolean }) => open,
      style: {
        ...openedMixin(theme),
        "& .MuiDrawer-paper": openedMixin(theme),
      },
    },
    {
      props: ({ open }: { open: boolean }) => !open,
      style: {
        ...closedMixin(theme),
        "& .MuiDrawer-paper": closedMixin(theme),
      },
    },
  ],
}));
